import {
  AccountService,
  CallHistoryService,
  ContactsService,
  MessagesService,
} from '@interfaces/index';

export class SorensonAccountService implements AccountService {
  contacts?: ContactsService;
  messages?: MessagesService;
  callHistory?: CallHistoryService;
  hasDialPad?: boolean;
  authToken?: unknown;
}
